<template>
  <div class="ysRegister">
    <div class="contain">
      <!-- <div class="title">医师注册</div> -->
      <div class="title"></div>
      <div class="register-form">
        <el-form ref="form" :model="form" label-width="125px" :rules="rules" :validate-on-rule-change="false" :auto-validate="false">
          <el-row>
            <el-col :span="24">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="医师姓名：" prop="realName">
                    <el-input size="small" v-model="form.realName" maxlength="20" show-word-limit placeholder="请输入医师姓名"
                      :disabled="displayNone1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机号:" prop="phone">
                    <el-input size="small" v-model="form.phone" placeholder="请输入手机号..." :disabled="phoneFlag"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="邮箱:" prop="email">
                    <el-input size="small" v-model="form.email" placeholder="请输入邮箱..." :disabled="emailFlag"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号:" prop="card">
                    <el-input size="small" v-model="form.card" placeholder="请输入身份证号..." :disabled="cardFlag"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="经营地址：" class="input3" prop="cityRegion">
                    <el-cascader v-model="form.cityRegion" :props="{ value: 'regionCode', label: 'regionName' }"
                      :options="addressLists" @change="addressChange" ref="cascader"
                      placeholder="请选择省/市/区/街道"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="详细地址:" prop="address">
                    <el-input type="textarea" :rows="2" size="small" v-model="form.address"
                      placeholder="请输入详细地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="上传身份证:" class="set-line-height-zero" ref="cardFront" prop="cardFront">
                <div class="upload-wrap fl">
                  <el-upload :show-file-list="false" class="avatar-uploader" :action="myFileUrl+'minio/upload'"
                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'cardFront')"
                    :before-upload="file =>beforeAvatarUpload(file, 'cardFront')">
                    <img v-if="form.cardFront" :src="$store.state.imgUrl+form.cardFront" class="avatar" />
                    <img v-else :src="require('@/assets/img/sz.png')" alt />
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item prop="cardReverse" ref="cardReverse" class="set-line-height-zero marginLeft0">
                <div class="upload-wrap fl">
                  <el-upload :show-file-list="false" class="avatar-uploader" :action="myFileUrl+'minio/upload'"
                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'cardReverse')"
                    :before-upload="file => beforeAvatarUpload(file, 'cardReverse')">
                    <img v-if="form.cardReverse" :src=" $store.state.imgUrl+form.cardReverse" class="avatar" />
                    <img v-else :src="require('@/assets/img/sf.png')" alt />
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="上传手持身份证:" class="set-line-height-zero" prop="peopleCardFront" ref="peopleCardFront">
                <div class="upload-wrap fl">
                  <el-upload :show-file-list="false" class="avatar-uploader" :action="myFileUrl+'minio/upload'"
                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'peopleCardFront')"
                    :before-upload="file => beforeAvatarUpload(file, 'peopleCardFront')">
                    <img v-if="form.peopleCardFront" :src="$store.state.imgUrl+form.peopleCardFront" class="avatar" />
                    <img v-else :src="require('@/assets/img/scsz.png')" alt />
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item prop="peopleCardReverse" ref="peopleCardReverse" class="set-line-height-zero marginLeft0">
                <div class="upload-wrap fl">
                  <el-upload :show-file-list="false" class="avatar-uploader" :action="myFileUrl+'minio/upload'"
                    :on-success="(res, file) => handleAvatarSuccess(res, file, 'peopleCardReverse')"
                    :before-upload="file => beforeAvatarUpload(file, 'peopleCardReverse')">
                    <img v-if="form.peopleCardReverse" :src=" $store.state.imgUrl+form.peopleCardReverse"
                      class="avatar" />
                    <img v-else :src="require('@/assets/img/scsf.png')" alt />
                  </el-upload>
                </div>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="执业医师证号:" prop="physicianCardNum">
                    <el-input size="small" v-model="form.physicianCardNum" placeholder="请输入执业医师证号..." maxlength="50"
                      show-word-limit></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="执业医师证:" class="set-line-height-zero" prop="physicianCardImg"
                    ref="physicianCardImg">
                    <div>
                      <el-upload class="avatar-uploader" :action="myFileUrl+'minio/upload'" list-type="picture-card"
                        :on-success="
                                                    (res, file) => handleAvatarSuccess(res, file, 'physicianCardImg')
                                                " :before-upload="file => beforeAvatarUpload(file, 'physicianCardImg')"
                        :on-remove="
                                                    (file, fileList) => handleRemove(file, fileList, 'physicianCardImg')
                                                " :file-list="physicianCardImgArr" :limit="2" :on-change="
                                                    (file, fileList) => handleEditChange(file, fileList, 'physicianCardImg')
                                                " :class="{hide:physicianCardImgHide}">
                        <img class="add3" :src="require('@/assets/img/add2.png')" alt />
                        <div slot="tip" class="el-upload__tip">最大1M；最多上传2张!</div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="个人照片:" class="set-line-height-zero" prop="picture" ref="picture">
                    <div class="upload-wrap fl yszzp">
                      <el-upload :show-file-list="false" class="avatar-uploader" :action="myFileUrl+'minio/upload'"
                        :on-success="(res, file) => handleAvatarSuccess(res, file, 'picture')"
                        :before-upload="file=>beforeAvatarUpload(file, 'picture')">
                        <img v-if="form.picture" :src="$store.state.imgUrl+form.picture" class="yszzp" />
                        <img v-else :src="require('@/assets/img/add2.png')" alt />
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="其他图片附件:" class="set-line-height-zero" ref="filePaths">
                    <div>
                      <el-upload class="avatar-uploader" :action="myFileUrl+'minio/upload'" list-type="picture-card"
                        :on-success="
                                                    (res, file) => handleAvatarSuccess(res, file, 'filePaths')
                                                " :before-upload="file => beforeAvatarUpload(file, 'filePaths')"
                        :on-remove="
                                                    (file, fileList) => handleRemove(file, fileList, 'filePaths')
                                                " :file-list="filePathsArr" :on-change="
                                                    (file, fileList) => handleEditChange(file, fileList, 'filePaths')
                                                ">
                        <img class="add3" :src="require('@/assets/img/add2.png')" alt />
                        <div slot="tip" class="el-upload__tip">最大1M</div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="擅长科室:" prop="adeptDepartments">
                    <el-select size="small" @change="selectChange" value-key="id" v-model="form.adeptDepartments"
                      filterable clearable multiple :multiple-limit="3" placeholder="请选择擅长科室..." style="width:100%">
                      <el-option v-for="item of sclyList" :key="item.id" :value="item.id"
                        :label="item.lableTwo"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职称:" prop="title">
                    <el-select size="small" v-model="form.title" filterable clearable placeholder="请选择职称..."
                      style="width:100%">
                      <el-option v-for="item of zcList" :key="item.lableTwo" :value="item.lableTwo"
                        :label="item.lableTwo"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="医院:" prop="hospital">
                    <el-input size="small" v-model="form.hospital" placeholder="请输入医院..."></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="科室:" prop="department">
                    <el-input size="small" v-model="form.department" placeholder="请输入科室..."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="自我简介">
                <el-input type="textarea" placeholder="请输入自我简介..." v-model.trim="form.introduceMyself"
                  :autosize="{ minRows: 4, maxRows: 8}" maxlength="500" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <el-checkbox class="login-form__tos" v-model="checked"></el-checkbox>
                <span class="tip">
                  已阅读并同意
                  <a href="#" @click="getUser()">《用户服务协议》</a>和
                  <a href="#" @click="getYiSi()">《隐私策略》</a>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="text-center">
            <el-col :span="24">
              <el-form-item class="cancle-margin-left">
                <el-button type="danger" @click="submitForm('form')" class="btn red">成为畅通圆医师</el-button>
                <!-- <el-button type="danger" @click="resetForm()" class="btn red">取消</el-button> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-dialog :title="title" :visible.sync="centerDialogVisible" width="60%" center class="mianUser">
                <span>{{content}}</span>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="centerDialogVisible = false">同 意</el-button>
                </span>
              </el-dialog>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="loginFlag" width="30%" center>
      <span> 更改信息提交成功！您需重新登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="goLogin">去登录</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rules from "@/common/rules";
  export default {
    name: "ysRegister",
    data() {
      const validatePhone = (rule, value, callback) => {
        const val = value.trim();
        if (val === "") {
          callback(new Error("请输入手机号"));
        } else if (!/^1\d{10}$/.test(val)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入登录密码"));
        } else {
          if (this.form.checkPass !== "") {
            this.$refs.form.validateField("checkPass");
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.form.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return {
        rules: {
          realName: [{
            required: true,
            message: "请输入医师姓名",
            trigger: "blur"
          }],
          address: [{
            required: true,
            message: "请输入详细地址",
            trigger: "blur"
          }],
          hospital: [{
            required: true,
            message: "请输入医院",
            trigger: "blur"
          }],

          password: [{
              validator: validatePass,
              trigger: "blur"
            },
            {
              required: true,
              message: "请输入登录密码",
              trigger: "blur"
            },
            {
              min: 6,
              max: 20,
              message: "长度在 6 到 20 个字符",
              trigger: "blur"
            }
          ],
          checkPass: [{
              validator: validatePass2,
              trigger: "blur"
            },
            {
              required: true,
              message: "请输入确认密码",
              trigger: "blur"
            },
            {
              min: 6,
              max: 20,
              message: "长度在 6 到 20 个字符",
              trigger: "blur"
            }
          ],
          department: [{
            required: true,
            message: "请输入科室",
            trigger: "blur"
          }],
          id: [{
            required: true,
            message: "请输入医师编号",
            trigger: "blur"
          }],
          cardFront: [{
            required: true,
            message: "请上传身份证反面照"
          }],
          cardReverse: [{
            required: true,
            message: "请上传身份证正面照"
          }],
          peopleCardFront: [{
            required: true,
            message: "请上传手持身份证反面照"
          }],
          peopleCardReverse: [{
            required: true,
            message: "请上传手持身份证正面照"
          }],
          physicianCardImg: [{
            required: true,
            message: "请上传执业医师证"
          }],
          picture: [{
            required: true,
            message: "请上传个人照片"
          }],
          sex: [{
            required: true,
            message: "请选择性别",
            trigger: "blur"
          }],
          adeptDepartments: [{
            required: true,
            message: "请选择擅长科室",
            trigger: "change"
          }],
          title: [{
            required: true,
            message: "请选择职称",
            trigger: "change"
          }],
          email: [{
              required: true,
              message: "请输入邮箱",
              trigger: "blur"
            },
            {
              type: "email",
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"]
            }
          ],
          phone: [{
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }],
          card: [{
              required: true,
              message: "请输入身份证号",
              trigger: "blur"
            },
            {
              validator: rules.FormValidate.Form().ID,
              trigger: "blur"
            }
          ],
          cityRegion: [{
            required: true,
            message: "请选择经营地址",
            trigger: "change"
          }],
          physicianCardNum: [{
              required: true,
              message: "请输入医师证号",
              trigger: "blur"
            },
            {
              validator: rules.FormValidate.Form().validateCodeYiNum,
              trigger: "blur"
            }
          ]
        },
        form: {
          id: "",
          realName: "",
          phone: "",
          email: "",
          card: "",
          physicianCardNum: "",
          adeptDepartments: [],
          hospital: "",
          title: "",
          department: "",
          sex: "",
          cardFront: "",
          cardReverse: "",
          physicianCardImg: "",
          headImg: "",
          introduceMyself: "",
          peopleCardFront: "",
          peopleCardReverse: "",
          picture: "",
          password: "",
          checkPass: "",
          userId: ""
        },
        checked: true,
        centerDialogVisible: false,
        title: "",
        content: "",
        displayNone1: false, //不显示
        disabledEmail: false, //邮箱是否可编辑
        disabledCard: false, //身份证是否可编辑
        physicianCardImgHide: false,
        physicianCardImgArr: [],
        addressLists: [], //存储省市区下拉列表数据
        cityCode: [], //选中的citycode
        cityTitle: [], //选中的cityname
        editFlag: false, //用于判断是否是编辑
        loginFlag: false, //去登陆弹窗
        filePaths: '', //其他图片字符串
        filePathsArr: [], //其他图片数组
        phoneFlag: true,
        emailFlag:true,
        cardFlag:true
      };
    },
    methods: {
      goLogin() {
        let that = this;
        sessionStorage.clear();
        that.$router.replace({
          path: "/login"
        });
      },
      getAddressList() {
        var params = {};
        let url = "/city/getCityList";
        this.$http.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.addressLists = res.data.data;

          }
        });
      },
      getData() {
        let that = this;
        let params = {};
        let url = "/physician/getPhysician";
        that.$http
          .post(url, params)
          .then(res => {
            res = res.data;
            if (res.code == 200) {
              this.form = {
                realName: res.data.realName,
                phone: res.data.phone?that.decrypt(res.data.phone, '6TuKlX4mwNflf95I'):'',
                email: res.data.email?that.decrypt(res.data.email, '6TuKlX4mwNflf95I'):'',
                card: res.data.card?that.decrypt(res.data.card, '6TuKlX4mwNflf95I'):'',
                physicianCardNum: res.data.physicianCardNum,
                city: res.data.city,
                address: res.data.address,
                hospital: res.data.hospital,
                department: res.data.department,
                title: res.data.title?res.data.title:'',
                introduceMyself: res.data.introduceMyself,
                adeptDepartments: res.data.adeptDepartments?res.data.adeptDepartments:[],
                adeptDepartment: res.data.adeptDepartment,
                cardFront: res.data.cardFront,
                cardReverse: res.data.cardReverse,
                peopleCardFront: res.data.peopleCardFront,
                peopleCardReverse: res.data.peopleCardReverse,
                physicianCardImg: res.data.physicianCardImg,
                picture: res.data.picture
              };
             this.phoneFlag = res.data.phone?true:false;
             this.emailFlag = res.data.email?true:false;
              this.cardFlag = res.data.card?true:false;
              that.form.cityRegion = res.data.city?res.data.city.split(","):[];
              if(res.data.adeptDepartment){
                const result = [];
                let arr = JSON.parse(res.data.adeptDepartment);
                for (let i = 0; i < arr.length; i++) {
                  result.push(arr[i].code)
                }
                 this.form.adeptDepartments = result;
              }
             
              let physicianCardImgList = res.data.physicianCardImg.split(',');
              let filePaths = res.data.filePaths.split(',');
              if (physicianCardImgList.length && physicianCardImgList[0]) {
                for (let j = 0; j < physicianCardImgList.length; j++) {
                  that.physicianCardImgArr.push({
                    url: that.$store.state.imgUrl + physicianCardImgList[j]
                  });
                }
                that.physicianCardImgHide = physicianCardImgList.length >= 2;
              }
              if (filePaths.length && filePaths[0]) {
                for (let j = 0; j < filePaths.length; j++) {
                  that.filePathsArr.push({
                    url: that.$store.state.imgUrl + filePaths[j]
                  });
                }
              }
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(() => {});
      },
      //文件上传的格式判断
      beforeAvatarUpload(file, type) {
        const allowedTypes = ['image/jpeg', 'image/png'];
        let isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!allowedTypes.includes(file.type)) {
          isJPG = false;
          this.$message.error('请上传正确格式图片');
          return false;
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1MB!");
        }
        return isJPG && isLt2M;
      },

      //上传成功
      handleAvatarSuccess(res, file, k) {
        let that = this;
        this.form[k] = res.data;
        if (res.code == 200) {
          that.$message.success("上传成功");
          this.form[k] = res.data.bpath;
          if (k == "physicianCardImg") {
            this.form.physicianCardImg === undefined ? "" : this.form.physicianCardImg += "," + res.data.bpath;
          }
          if (k == "filePaths") {
            this.filePaths === undefined ? "" : this.filePaths += "," + res.data.bpath;
          }
          that.$refs[k].clearValidate();

        } else {
          that.$message.error("上传失败");
        }
      },
      /**
       * 移除文件参数说明 file,fileList为回调函数自带参数 type判断视频,图片,还是图片详情
       */
      handleRemove(file, fileList, type) {
        let that = this;
        let prefix = that.$store.state.imgUrl;
        let fileUrl = [];
        var str = "";
        if (fileList.length > 0) {
          for (var i = 0; i < fileList.length; i++) {
            if (fileList[i].response) {
              str = fileList[i].response.data.bpath;
            } else {
              str = fileList[i].url;
            }
            if (str.startsWith(prefix)) {
              //原始字符串包含指定前缀
              const remainingStr = str.slice(prefix.length);
              fileUrl.push(remainingStr);
            } else {
              //原始字符串不包含指定前缀
              fileUrl.push(str);
            }
          }
          if (type == "physicianCardImg") {
            this.form.physicianCardImg = fileUrl.join(",");
          }
          if (type == "filePaths") {
            this.filePaths = fileUrl.join(",");
          }
        } else {
          if (type == "physicianCardImg") {
            this.form.physicianCardImg = "";
            that.physicianCardImgHide = fileList.length >= 2;
          }
          if (type == "filePaths") {
            this.filePaths = "";
          }
        }
      },
      handleEditChange(file, fileList, type) {
        let that = this;
        if (type == "physicianCardImg") {
          that.physicianCardImgHide = fileList.length >= 2;
        }
      },
      submitForm(formName) {
        let that = this; 
        let form = that.form;
        form.physicianCardImg = that.form.physicianCardImg.trim().replace(/^,|,$/g, ''); //去除前后逗号 
        form.filePaths = that.filePaths.trim().replace(/^,|,$/g, ''); //去除前后逗号
        that.$refs[formName].validate(async valid => {
          if (!valid) return;
          if (that.checked) {
            //申请成为医师
            let url = "/physician/applyForPhysician";
            let param = Object.assign({},form)
            param.cityRegion = this.$refs["cascader"].getCheckedNodes()[0].pathLabels.join();
            that.$http
              .post(url, param)
              .then(res => {
                res = res.data;
                if (res.code == 200) {
                  if (that.editFlag) {
                    this.loginFlag = true;
                    sessionStorage.clear();
                  } else {
                    that.$message({
                      type: "success",
                      message: "申请提交成功，管理员审核中..."
                    });
                    that.$router.replace({
                      path: "/doctorInfo"
                    });
                  }
                  // // 刷新兄弟组件
                  // let NewPage =
                  //     "_empty" +
                  //     "?time=" +
                  //     new Date().getTime() / 500;
                  // this.$router.push(NewPage);
                  // this.$router.go(-1);
                } else {
                  that.$message.error(res.msg);
                }
              })
              .catch(() => {});

          } else {
            this.$message({
              type: "warning",
              message: "请阅读《用户服务协议》和《隐私策略》"
            });
          }
        });
      },
      selectChange(e) {
        let result = [];
        for (let element of e) {
          for (let item of this.sclyList) {
            if (item.id === element) {
              result.push({
                code: item.id,
                value: item.lableTwo
              });
            }
          }
        }
        this.form.adeptDepartment = JSON.stringify(result);
      },
      addressChange(value) {
        // console.log(value,this.$refs["cascader"].getCheckedNodes()[0].pathLabels.join())
        // this.form.cityRegion = this.$refs["cascader"].getCheckedNodes()[0].pathLabels.join();
        this.form.city = value.join();
        console.log(this.form.cityRegion, this.form.city)
      },
    },
    created() {
      this.dataDictionary("ZC");
      this.dataDictionary("SCLY");
      this.getUserinfo();
      this.getData();
      this.getAddressList(); //获取地址下拉选项数据
      if (this.$route.query.type == "edit") {
        this.editFlag = true;
      } else {
        this.editFlag = false;
      }
    }
  };
</script>

<style scoped>
  /deep/.hide .el-upload--picture-card {
    display: none !important;
  }

  .contain {
    width: 1024px;
    margin: 0 auto;
  }

  .ysRegister {
    background-color: #f8f8f8;
    padding-bottom: 100px;
  }

  .title {
    padding: 40px 0px 20px 0px;
  }

  .register-form {
    background-color: #fff;
    padding: 40px 120px 70px 90px;
  }

  .upload-wrap {
    width: 181px;
    height: 113px;
    border: 1px solid #d6d6d6;
    margin-right: 20px;
    display: flex;
    align-items: center;
    border-radius: 6px;
  }

  .avatar-uploader {
    margin: 0 auto;
  }

  /* .yszzp,
.avataryszzp {
    width: 120px;
    height: 140px;
} */
  .avatar {
    width: 181px;
    height: 113px;
  }

  .el-upload img {
    vertical-align: middle;
  }

  .set-line-height-zero {
    display: inline-block;
  }

  .displayNoneClass {
    display: none;
  }

  .yszzp,
  .avataryszzp {
    width: 120px;
    height: 140px;
  }
</style>
<style>
  .marginLeft0 .el-form-item__content {
    margin-left: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/JW/ysRegister.vue